export default __webpack_public_path__ + "static/media/drinkwater.704eec6d.svg";